import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import FragmentPageItem from '@graphql/fragments/page.gql';
import FragmentProductList from '@graphql/fragments/product-list.gql';
import { IPage } from '@server/data/models/page';
import { List, Record, fromJS } from 'immutable';
import { IProduct } from '@server/data/models/product';

const QUERY = gql`
  query SearchProduct(
    $page: Int
    $limit: Int
    $orderBy: String
    $categoryId: Int
    $keyword: String
  ) {
    searchProduct(
      page: $page
      limit: $limit
      orderBy: $orderBy
      categoryId: $categoryId
      keyword: $keyword
    ) {
      products {
        ...ProductItem
      }
      page {
        ...PageItem
      }
    }
  }
  ${FragmentProductList}
  ${FragmentPageItem}
`;

interface ProductListResponse {
  loading: boolean;
  error: boolean;
  products?: List<IProduct>;
  page?: Record<IPage>;
}

interface ProductListVariables {}

export const useProductList = (variables: any): ProductListResponse => {
  const { loading, error, data } = useQuery(QUERY, {
    variables: variables,
    notifyOnNetworkStatusChange: true,
  });

  let products = List();
  let page = fromJS({});

  if (!!data && data.searchProduct) {
    products = fromJS(data.searchProduct.products);
    page = fromJS(data.searchProduct.page);
  }

  return {
    error: !!error,
    products,
    page,
    loading,
  };
};

export default useProductList;
